/* eslint-disable import/prefer-default-export */
export const quickRequestQueryKeys = {
  quickRequestListing: (filters: any) => ["quick-request", "list", filters],
  quickRequestDetails: (id?: string) => ["quick-request", "detail", id],
  quickRequestCommentsListing: (id: string) => ["quick-request", "list", id, "comments"],
  quickRequestShipmentDetails: (id: string) => ["quick-request", "detail", id, "shipment"],
};
